document.addEventListener("DOMContentLoaded", () => {
    const $body = document.querySelector('body'),
        $header = document.querySelector('.page-header'),
        $utilityBar = document.querySelector('.js-utility-bar'),
        barHeight = $utilityBar ? $utilityBar.offsetHeight : 0;

    //Sticky-header
    function stickyHeader() {
        if($(window).scrollTop() > barHeight) {
            $header.classList.add('sticky');
            $header.style.top = 0;
        } else {
            $header.classList.remove('sticky');
            $header.style.top = `${barHeight}px`;
        }
    }

    // if (window.matchMedia("(max-width: 1199px)").matches) {
    //     // $('.mega-menu-item-has-children > .mega-sub-menu').addClass('main-sub-menu');
    //     $('.mega-sub-menu').slideUp();
    //
    //     setTimeout(function () {
    //         $('.mega-menu-item-has-children > .mega-menu-link').on('click', function H(e) {
    //             e.preventDefault();
    //             $(this).parent().find('.mega-sub-menu').slideToggle();
    //             $(this).toggleClass('active');
    //         });
    //     }, 0);
    // }

    $( window ).on( "load resize", function() {
        if($(window).width() < 1200) {
            dl.log('fdg');
            $('.mega-sub-menu').slideUp();
            $('.main-nav').css('height', `${$( window ).height() - $('.js-page-header').height() - $('.js-header-buttons').height()}`);
        } else {
            $('.mega-sub-menu').slideDown();
            $('.main-nav').css('height', 'auto');
        }
    } );

    window.addEventListener('load', () => {
        $('#nav-icon').click(function H() {
            $(this).toggleClass('change-icon');
            $('.js-page-header').toggleClass('nav-open');
            $('body').toggleClass('body-overflow');
        });

        $('.mega-menu-item-has-children > .mega-menu-link').click(function H(e) {
            if($(window).width() < 1200) {
                e.preventDefault();
                dl.log('test');
                $(this).toggleClass('open');
                $(this).parent().find('.mega-sub-menu').slideToggle();
            }
        });
    });

    const mainNavLinks = document.querySelectorAll('nav.main-nav .mega-menu > .mega-menu-item > a');
    mainNavLinks.forEach(link => {
        link.addEventListener('mouseover', () => {
            mainNavLinks.forEach(otherLink => {
                if (otherLink !== link) {
                    otherLink.style.opacity = '0.5';
                }
            });
        });

        link.addEventListener('mouseout', () => {
            mainNavLinks.forEach(otherLink => {
                if (otherLink !== link) {
                    otherLink.style.opacity = '1';
                }
            });
        });
    });

    window.addEventListener('resize', () => {
        //
    });

    document.addEventListener('scroll', () => {
        stickyHeader();
    });
});
